<template>
  <div
    class="tw-w-full tw-h-10 tw-flex tw-items-end tw-animate-pulse"
    role="status"
  >
    <div
      class="tw-bg-primary-grey-400 tw-w-20 tw-h-4 tw-mr-2 tw-rounded-full"
    ></div>
    <div class="tw-bg-primary-grey-400 tw-w-10 tw-h-4 tw-rounded-full"></div>
    <span class="tw-sr-only">Loading...</span>
  </div>
</template>
